export default __webpack_public_path__ + "d435b5920ca9f5cf5a597b7f85513343.jpeg";